import { DendromapLoader } from '@repo/ui/components/dendromap-loader';
import { lazy, Suspense } from 'react';

const GeoLayersAdminPage = lazy(() => import('@repo/ui/features/geo-layers').then((mod) => ({ default: mod.GeoLayersAdminPage })));

export default function GeoLayersAdminRoute() {
  return (
    <Suspense fallback={<DendromapLoader message="Chargement des couches géographiques..." />}>
      <GeoLayersAdminPage />
    </Suspense>
  );
}
